import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, Lock } from "lucide-react";
import { Logo } from "./Logo";
import { SocialLinks } from "./Social";
import { LightsButton } from "./LightsButton";

export const NAV = [
  { to: "/", label: "Home", id: "home" },
  { to: "/uscite", label: "Uscite", id: "uscite" },
  { to: "/generi", label: "Generi", id: "generi" },
  { to: "/servizi", label: "Servizi", id: "servizi" },
  { to: "/artisti", label: "Artisti", id: "artisti" },
  { to: "/chi-siamo", label: "Chi siamo", id: "chi-siamo" },
  { to: "/contatti", label: "Contatti", id: "contatti" },
];

const linkCls = ({ isActive }) =>
  `font-mono-tga text-xs uppercase tracking-[0.2em] transition-colors duration-200 ${isActive ? "text-emerald-400" : "text-zinc-300 hover:text-white"}`;

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#151827]/80 border-b border-white/10" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between gap-6">
        <Logo />
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink key={n.id} to={n.to} end={n.to === "/"} className={linkCls} data-testid={`nav-${n.id}-link`}>{n.label}</NavLink>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <LightsButton />
          <SocialLinks prefix="header-social" />
          <Link to="/admin" data-testid="nav-admin-link" aria-label="Area admin"
            className="h-10 w-10 grid place-items-center rounded-full border border-white/10 text-zinc-400 hover:text-white hover:border-white/30 transition-colors">
            <Lock className="h-4 w-4" />
          </Link>
        </div>
        <div className="lg:hidden flex items-center gap-2">
          <LightsButton testid="mobile-lights-toggle-btn" />
          <button className="p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[#050507] px-5 py-6 flex flex-col gap-5" data-testid="mobile-menu">
          {NAV.map((n) => (
            <NavLink key={n.id} to={n.to} end={n.to === "/"} className={linkCls} onClick={() => setOpen(false)} data-testid={`mobile-nav-${n.id}-link`}>{n.label}</NavLink>
          ))}
          <div className="flex items-center gap-3">
            <SocialLinks prefix="mobile-social" />
            <Link to="/admin" onClick={() => setOpen(false)} data-testid="mobile-nav-admin-link" className="font-mono-tga text-xs uppercase tracking-[0.2em] text-zinc-500">Area admin</Link>
          </div>
        </div>
      )}
    </header>
  );
}
